import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', 'px;\n  line-height: ', ';\n  font-weight: 600;\n  ', ' ', ';\n'], ['\n  font-size: ', 'px;\n  line-height: ', ';\n  font-weight: 600;\n  ', ' ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: none;\n  '], ['\n    display: none;\n  ']);

import styled from 'styled-components';
import { whenCollapsedAndNotInOverflowDropdown } from '../../theme/util';
import { truncate } from '../../utils/mixins';
import { gridSize } from '../../shared-variables';

var groupTitleFontSize = 11;

var NavigationItemGroupTitle = styled.div(_templateObject, groupTitleFontSize, gridSize * 2 / groupTitleFontSize, truncate(), whenCollapsedAndNotInOverflowDropdown(_templateObject2));

NavigationItemGroupTitle.displayName = 'NavigationItemGroupTitle';
export default NavigationItemGroupTitle;